import React from "react";
import classnames from "classnames";

const BoostFeatureComponent = (props) => {
  const { feature, large, shortDesc, noDesc } = props;

  const { iconSrc, iconWidth_Big, iconWidth_Normal, header, description, shortDescription, comingSoon } = feature;

  const featureClassNames = classnames({
    "boost-feature": true,
    "boost-feature_large": large,
  });

  return (
    <div className={featureClassNames}>
      <div className="feature_icon-container">
        <div style={{ position: "relative" }}>
          <img className="feature_icon" src={iconSrc} width={large ? iconWidth_Big : iconWidth_Normal} />
          {comingSoon && (
            <img className="coming-soon-tag" src="https://static.bigbrain.gg/assets/ugg/pages/landing/coming-soon.svg" />
          )}
        </div>
      </div>
      <div className="feature_header">{header}</div>
      {!noDesc && <div className="feature_description">{shortDesc ? shortDescription : description}</div>}
    </div>
  );
};

export default BoostFeatureComponent;
